import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
/**
 * `/proposal/:id` (index) → `/proposal/:id/v2/home` (FND-23, OD-60).
 *
 * Proposal v2 is the only proposal UI: no flag is read and `?legacy=1` is
 * ignored. Search and hash survive (`?submission=…`, `#proposal-milestones`).
 * The target is relative to the `proposal/:id` parent route.
 */ export function ProposalIndexRedirect() {
    const { search, hash } = useLocation();
    return /*#__PURE__*/ _jsx(Navigate, {
        replace: true,
        to: {
            pathname: 'v2/home',
            search,
            hash
        }
    });
}
